import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-005ea03a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "grid-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ExcellentWorkCard = _resolveComponent("ExcellentWorkCard");
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_row = _resolveComponent("a-row");
  var _component_WorkDetail = _resolveComponent("WorkDetail");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_row, {
    type: "flex",
    gutter: [20, 40],
    justify: "start",
    wrap: true
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item) {
        return _openBlock(), _createBlock(_component_a_col, {
          key: item.id,
          span: 6
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_ExcellentWorkCard, {
              onSelect: _ctx.onCardSelect,
              work: item
            }, null, 8, ["onSelect", "work"])];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _ctx.selectedCard ? (_openBlock(), _createBlock(_component_WorkDetail, {
    creation: _ctx.selectedCard,
    key: _ctx.selectedCard.id
  }, null, 8, ["creation"])) : _createCommentVNode("", true)]);
}